<template>
  <el-dialog :visible.sync="dialogVisible" :fullscreen="true" :show-close="false" @close="handleClose">
    <div class="diaInner" id="diaInner">
      <h3 class="diainner_title">
        受限空间安全作业证
        <div class="diainner_title_num">编号：{{ message.no }}</div>
      </h3>
      <table border="1">
        <tr>
          <td class="title" :colspan="2">申请单位</td>
          <td :colspan="3">{{ message.applicant?.contrName }}</td>
          <!-- <td class="title">申请人</td>
          <td>{{ getUserName(message.applyUserId) }}</td> -->
          <td class="title" :colspan="2">作业申请时间</td>
          <td :colspan="3">{{ message.applyTime }}</td>
        </tr>
        <tr>
          <td class="title" :colspan="2">受限空间名称</td>
          <td :colspan="3">{{ message.businessJson.csn }}</td>
          <td class="title" :colspan="2">受限空间内原有介质名称</td>
          <td :colspan="3">{{ message.businessJson.csmn }}</td>
        </tr>
        <tr>
          <td class="title" :colspan="2">作业内容</td>
          <td :colspan="8" class="keepLeft">{{ message.businessJson.content }}</td>
        </tr>
        <tr>
          <td class="title" :colspan="2">作业单位</td>
          <td :colspan="3" class="keepLeft">{{ message.businessJson.unit }}</td>
          <td class="title" :colspan="2">作业负责人</td>
          <td :colspan="3" class="keepLeft">{{ getUserName(message.businessJson.companyCharger) }}</td>
        </tr>
        <tr>
          <td class="title" :colspan="2">监护人</td>
          <td :colspan="3" class="keepLeft">{{ getUserName(message.businessJson.guardianId) }}</td>
          <td class="title" :colspan="2">作业人</td>
          <td :colspan="3" class="keepLeft">{{ getUserName(message.jobExecutorEmpId) }}</td>
        </tr>
        <tr>
          <!-- <td class="title" :colspan="2">涉及的其他特殊作业</td>
          <td :colspan="2">{{ message.businessJson.tszy }}</td> -->
          <td class="title" :colspan="2">涉及的其他特殊作业安全作业证编号</td>
          <td :colspan="8" class="keepLeft">{{ message.businessJson.tszyzno }}</td>
        </tr>
        <tr>
          <td class="title" :colspan="2">风险辨识结果</td>
          <td :colspan="8" class="keepLeft">{{ message.businessJson.hi }}</td>
        </tr>
<!--        <tr>
          <td class="title" :colspan="2">涉及的其他特殊作业及编号</td>
          <td :colspan="7">{{ formatPreWorkInfo() }}</td>
        </tr>-->
        <tr>
          <td class="title" :colspan="2">分析项目</td>
          <td class="title" :colspan="2">有毒有害物质</td>
          <td class="title" :colspan="2">可燃气</td>
          <td class="title" :rowspan="2">氧含量</td>
          <td class="title" :rowspan="3">时间</td>
          <td class="title" :rowspan="3">部位</td>
          <td class="title" :rowspan="3">分析人</td>
        </tr>
        <tr>
          <td class="title" :colspan="2">分析标准</td>
          <td>{{ message.businessJson.restrictedAnalysis[0].toxicGas }}</td>
          <td>{{ message.businessJson.restrictedAnalysis[0].toxicGas2 }}</td>
          <td>{{ message.businessJson.restrictedAnalysis[0].combustibleGas }}</td>
          <td>{{ message.businessJson.restrictedAnalysis[0].combustibleGas2 }}</td>
        </tr>
        <tr>
          <td class="title" :colspan="2">合格标准</td>
          <td>{{ message.businessJson.restrictedAnalysis[1].toxicGas }}</td>
          <td>{{ message.businessJson.restrictedAnalysis[1].toxicGas2 }}</td>
          <td>{{ message.businessJson.restrictedAnalysis[1].combustibleGas }}</td>
          <td>{{ message.businessJson.restrictedAnalysis[1].combustibleGas2 }}</td>
          <td>
            19.5%~21%
            <br/>
            (体积分数)
          </td>
        </tr>
        <template v-for="(item, index) in message.businessJson.restrictedAnalysis.slice(2, 7)">
          <tr>
            <td :key="index + '' + item.toxicGas" v-if="index === 0"
              :rowspan="message.businessJson.restrictedAnalysis.length - 2" class="title" :colspan="2">分析数据</td>
            <td>{{ item.toxicGas }}</td>
            <td>{{ item.toxicGas2 }}</td>
            <td>{{ item.combustibleGas }}</td>
            <td>{{ item.combustibleGas2 }}</td>
            <td>{{ item.oxygenContent }}</td>
            <td>{{ item.time }}</td>
            <td>{{ item.position }}</td>
            <td :colspan="2">{{ getUserName(item.assayerId) }}</td>
          </tr>
        </template>
        <tr>
          <td class="title" :colspan="2">作业实施时间</td>
          <td :colspan="8" class="keepLeft">{{ message.actualStartTime }} - {{ message.actualEndTime }}</td>
        </tr>
        <tr>
          <td class="title">序号</td>
          <td class="title" :colspan="6">安全措施</td>
          <td class="title" :colspan="2">是否涉及</td>
          <td class="title">确认人</td>
        </tr>
        <tr v-for="(item3, index3) in message.businessJson.sms" :key="index3 + '-' + item3.confirmorId">
          <td>{{ index3 + 1 }}</td>
          <td :colspan="6" class="keepLeft">{{ item3.measures }}</td>
          <td :colspan="2">{{ item3.isInvolve == 1 ? '是' : '否' }}</td>
          <td><i v-html="getSignatureImg(item3.orderNo, 40)" /></td>
        </tr>
        <tr>
          <td :colspan="2" class="title">安全交底人</td>
          <td :colspan="3">{{ getUserName(message.businessJson.aqjdrId) }}</td>
          <td :colspan="2" class="title">接受交底人</td>
          <td :colspan="3">{{ getUserName(message.businessJson.jsjdrId) }}</td>
        </tr>
        <tr>
          <td :colspan="10">
            <div class="fireplayidea_title">作业负责人意见</div>
            <div class="fireplayidea_cont">{{ message.businessJson.companyChargerComment }}</div>
            <div class="fireplayidea_right">
              <span>签字：<i v-html="getSignatureImg(message.businessJson.companyChargerOrder, 60)" /></span>
              <span>签字时间：{{ message.businessJson.companyChargerTime }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td :colspan="10">
            <div class="fireplayidea_title">审批单位负意见</div>
            <div class="fireplayidea_cont">{{ message.businessJson.approveChargerComment }}</div>
            <div class="fireplayidea_right">
              <span>签字：<i v-html="getSignatureImg(message.businessJson.approveChargerOrder, 60)" /></span>
              <span>签字时间：{{ message.businessJson.approveChargerTime }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td :colspan="10">
            <div class="fireplayidea_title">完工验收</div>
            <div class="fireplayidea_cont">{{ message.acceptanceOpinion }}</div>
            <div class="fireplayidea_right">
              <span>签字：<i v-html="getSignatureImg(0, 60)" /></span>
              <span>签字时间：{{ message.acceptanceTime }}</span>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <span slot="footer" class="diaFooter">
      <el-button @click="handleClose" size="small">取 消</el-button>
      <el-button v-if="!isWork" type="primary" v-print="'#diaInner'" size="small">打 印</el-button>
    </span>
  </el-dialog>
</template>

<script>
import signatureImg from "@/assets/img/签字.png";

export default {
  name: 'restrictedSpace',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    message: {
      type: Object,
      default: {}
    },
    userList: {
      type: Array,
      default: []
    },
    isWork: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {

    }
  },
  methods: {
    formatPreWorkInfo() {
      if (!this.message.preWorkInfo) {
        return
      }
      let str = []
      let data = JSON.parse(this.message.preWorkInfo)
      for (var i = 0; i < data.length; i++) {
        let element = data[i]
        str.push(`${element.name}(${element.no})`)
      }
      str = str.join(',')
      return str
    },
    handleClose() {
      this.$emit('componentResult', false)
    },
    getUserName(id) {
      for (let i in this.userList) {
        if (Number(id) === this.userList[i].id) {
          return this.userList[i].name
        }
      }
    },
    getSignatureImg(orderNum, height = 40) {
      let signatureImg = require('@/assets/img/签字.png');
      let signatureImgHeight = 'auto';
      for (let i in this.message.reviewContentJson) {
        if (orderNum === this.message.reviewContentJson[i].orderNum) {
          let img = this.message.reviewContentJson[i].signatureImg;
          if (img) {
            signatureImg = img;
            signatureImgHeight = height + 'px'
          }
        }
      }
      return '<img style="height: ' + signatureImgHeight + '" src="' + signatureImg + '"/>';
    },
  }
}
</script>

<style src="./commonTable.css" scoped></style>

<style>
.diaInner {
  width: 1020px;
  margin: auto;
}

table {
  width: 1020px;
}

td {
  width: 150px;
}

.diainner_title {
  text-align: center;
  font-size: 28px;
  position: relative;
}

.diainner_title .diainner_title_num {
  position: absolute;
  right: 0;
  bottom: 0;
  font-size: 14px;
  font-weight: normal;
}

.fireplayidea_title {
  font-size: 14px;
  text-align: left;
  font-weight: bold;
}

.fireplayidea_cont {
  line-height: 22px;
  text-align: left;
  margin: 10px 0;
}

.fireplayidea_right {
  text-align: right;
}

.fireplayidea_right span {
  margin-left: 10px;
  width: 220px;
  display: inline-block;
  text-align: left;
}
</style>
